/**
 * About section with company information
 */
function About() {
	return (
		<section id="about" className="about">
			<div className="section-container">
				<div className="about-content">
					<h2 className="section-title">About 3oh</h2>
					<p className="about-text">
						We are a technology studio at the intersection of Web3 and artificial intelligence. 
						Our team combines deep expertise in blockchain protocols, smart contract development, 
						and machine learning to deliver solutions that push the boundaries of what's possible.
					</p>
					<p className="about-text">
						From early-stage startups to established enterprises, we partner with visionary teams 
						to build products that matter. Our approach is collaborative, transparent, and focused 
						on delivering real value.
					</p>
					<div className="about-stats">
						<div className="stat">
							<span className="stat-number">50+</span>
							<span className="stat-label">Projects Delivered</span>
						</div>
						<div className="stat">
							<span className="stat-number">Web3</span>
							<span className="stat-label">Native Expertise</span>
						</div>
						<div className="stat">
							<span className="stat-number">AI</span>
							<span className="stat-label">Powered Solutions</span>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default About;
